
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

class GiftVoucherIssue {

  edit = async (customer: any, code: any) => {
    await axios.put(`${API_URL}royalty-points/${code}`, customer)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  };

  get = async (code: any) => {
    const response = await axios.get<any>(`${API_URL}royalty-points/${code}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.royaltyPoints;
  };

  getAll = async () => {
    const response = await axios.get<any>(`${API_URL}royalty-points`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.royaltyPoints;
  };
}
export default new GiftVoucherIssue();
